import {useNavigate} from "react-router-dom";


export default function Welcome(){
    let navigate = useNavigate();

    return(
        <div style={{fontFamily:'Montserrat'}} className='h-screen w-screen flex bg-gradient-to-t from-blue-900 to-blue-400 items-center justify-center'>

          <div className="flex flex-col justify-center items-center">
            
            <div className="w-72 md:w-2/5 backdrop-blur-sm rounded-md">
              <img src="/logo.png"/>
            </div>

            <button 
                onClick={()=>{
                    navigate("/signup");
                }}
            className="shadow-xl hover:scale-105 mt-24 w-72 text-white font-bold text-2xl bg-yellow-400 p-3 rounded-sm">
              Sign Up
            </button>

            <button
                onClick={()=>{
                    navigate("/login");
                }} 
            className="shadow-xl hover:scale-105 mt-12 w-72 text-blue-900 font-bold text-2xl bg-white p-3 rounded-sm">
              Log In
            </button>

          </div>

    </div>
    )
}